import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
